import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import {
	StyledTextFieldErrorMessage,
	StyledTextFieldLabel,
} from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { StyledMicroformInputContainer } from './StyledMicroformInputContainer';
import { usePaymentContext } from '../../../../../parking/ui/booking-steps/payment/PaymentContext';

const SECURITY_CODE_ID = 'security-code';
const SECURITY_CODE_LABEL = 'credit-card-security-code';

export const MicroformCVV = () => {
	const { t } = useTranslation();
	const [showPossibleError, setShowPossibleError] = useState(false);
	const { setIsNewCardCVVValid, isNewCardCVVValid } = usePaymentContext();
	const { microformInstance } = usePaymentContext();

	const securityCodeFieldCreated = useRef(false);

	useEffect(() => {
		if (!microformInstance || securityCodeFieldCreated.current) {
			return undefined;
		}
		const cvv = microformInstance.createField('securityCode', {
			placeholder: t('payment_form_cvv_placeholder'),
		});
		cvv.on('change', (data) => {
			setIsNewCardCVVValid(data.valid);
		});
		cvv.on('blur', () => {
			setShowPossibleError(true);
		});
		cvv.load(`#${SECURITY_CODE_ID}`);
		securityCodeFieldCreated.current = true;

		return () => {
			cvv.dispose();
		};
	}, [microformInstance]);

	if (!microformInstance) {
		return null;
	}

	return (
		<>
			<StyledTextFieldLabel id={SECURITY_CODE_LABEL}>
				{t('payment_form_cvv_label')}
			</StyledTextFieldLabel>
			<StyledCVVInputContainer
				id={SECURITY_CODE_ID}
				aria-labelledby={SECURITY_CODE_LABEL}
				className="form-control"
			/>
			{showPossibleError && !isNewCardCVVValid && (
				<StyledTextFieldErrorMessage role="alert">
					{t('payment_form_cvv_pattern_error')}
				</StyledTextFieldErrorMessage>
			)}
		</>
	);
};

const StyledCVVInputContainer = styled(StyledMicroformInputContainer)`
	width: 50%;
`;
